export default {
    explainer: "2",
    navbar: "2"
}


// WEBPACK FOOTER //
// ./src/util/js/config.js